import React, { useContext, useEffect, useRef, useState } from "react";
import "../../../../styles/workspace_styles/TenantAdministratorStyles/Customers/Customers.css";
import {thingsBoardMicroserviceUrl} from "../../../../microservices/thingsboard_microservice.js";
import { LoadShortDate } from "../../../../functions/LoadShortDate.js";
import { LoadShortTime } from "../../../../functions/LoadShortTime.js";
import Customer from "./Customer.jsx";
import NewCustomer from "./NewCustomer.jsx";
import { AppContext } from "../../../AppProvider.jsx";
import NavigationBar from "../../../navigation_components/NavigationBar.jsx";
import TenantAdministratorSideBar from "../../../sidebar_components/TenantAdministratorSideBar.jsx";
import CustomerProvider, { CustomerContext } from "./CustomerProvider.jsx";
import { useLocation, useNavigate } from "react-router-dom";
function CustomersTable({customers,access_token,selectedServerUrl,setSelectedComponent}){
    const[selectedCustomer,setSelectedCustomer] = useState();
    const[customersSortType,setCustomersSortType] = useState('title-ascending');
    if(!Array.isArray(customers) || customers.length === 0) return null;
    return(
        <div className="tenant-administrator-customers-table-container">
            <table className="tenant-administrator-customers-table">
                <thead>
                    <tr id="tenant-administrator-customers-table-header-row">
                        <th onClick={() =>{
                            if(customersSortType === 'title-ascending') setCustomersSortType('title-descending');
                            else setCustomersSortType('title-ascending');
                        }}>Title</th>
                        <th>Date created</th>
                        <th>Time created</th>
                        <th>Email address</th>
                        <th onClick={() =>{
                            if(customersSortType === 'country-ascending') setCustomersSortType('country-descending');
                            else setCustomersSortType('country-ascending');
                        }}>Country</th>
                        <th onClick={() =>{
                            if(customersSortType === 'city-ascending') setCustomersSortType('city-descending');
                            else setCustomersSortType('city-ascending');
                        }}>City</th>
                    </tr>
                </thead>
                <tbody>
                    {[...customers].filter(customer => customer?.external?.title !== 'Public').sort((a,b) =>{
                        if(customersSortType === 'title-ascending') return a?.external?.title?.localeCompare(b?.external?.title);
                        else if(customersSortType === 'title-descending') return b?.external?.title?.localeCompare(a?.external?.title);
                        if(customersSortType === 'country-ascending') return a?.external?.country?.localeCompare(b?.external?.country);
                        else if(customersSortType === 'country-descending') return b?.external?.country?.localeCompare(a?.external?.country);
                        if(customersSortType === 'city-ascending') return a?.external?.city?.localeCompare(b?.external?.city);
                        else if(customersSortType === 'city-descending') return b?.external?.city?.localeCompare(a?.external?.city);
                        else return 0;
                    }).map(customer =>{
                        return (
                            <tr key={customer.external.id} onClick={() =>{setSelectedCustomer(customer)}}>
                                <td>{customer?.external?.title}</td>
                                <td>{LoadShortDate(customer.external.createdTime)}</td>
                                <td>{LoadShortTime(customer.external.createdTime)}</td>
                                <td>{customer.external.email}</td>
                                <td><div>{customer.external.country}</div></td>
                                <td><div>{customer.external.city}</div></td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
            <CustomerProvider>
                <Customer
                    customer={selectedCustomer}
                    setCustomer={setSelectedCustomer}
                    setSelectedComponent={setSelectedComponent}
                    selectedServerUrl={selectedServerUrl}
                    access_token={access_token}
                />
            </CustomerProvider>
        </div>
    );
}
const Customers = () =>{
    const {user,setSelectedComponent,logout} = useContext(AppContext);
    const [tenantAdminProfiles,setTenantAdminProfiles] = useState([]);
    const [tenantAdminProfilesFetched,setTenantAdminProfilesFetched] = useState(false);
    const [customers,setCustomers] = useState([]);
    const [customersFetched,setCustomersFetched] = useState(true);
    const [showNewCustomerWindow,setShowNewCustomerWindow] = useState(false);
    const {selectedTenantAdminProfile,setSelectedTenantAdminProfile} = useContext(CustomerContext);
    const logoutTimerRef = useRef(null);
    const navigate = useNavigate();
    const location = useLocation();
    const fetchServerProfiles = async() =>{
        try{
            const url = `${thingsBoardMicroserviceUrl}/tenants/profiles/all/get`;
            const response = await fetch(url,{
                method:'GET',
                headers:{
                    'Authorization':`Bearer ${user.access_token}`,
                    'Content-Type':'application/json'
                }
            });
            if(Number(response.status) === 401) logout();
            const responseData = await response.json();
            setTenantAdminProfiles(responseData);
        }
        catch(error){
            console.error(error);
        }
        setTenantAdminProfilesFetched(true);
    };
    const fetchCustomers = async() =>{
        try{
            const url = `${thingsBoardMicroserviceUrl}/tenants/profiles/${selectedTenantAdminProfile?.id}/customers`;
            const response = await fetch(url,{
                method:'GET',
                headers:{
                    'Authorization':`Bearer ${user.access_token}`,
                    'Content-Type':'application/json'
                }
            });
            if(response.ok){
                const responseData = await response.json();
                setCustomers(responseData);
            }
            else if(Number(response.status) === 401) logout();
            else throw new Error(`status code: ${response.status}`);
        }
        catch(error){
            console.error(error);
        }
    };
    useEffect(() =>{
        if(tenantAdminProfilesFetched) return;
        if(!user){
            logoutTimerRef.current = setTimeout(() =>{
                navigate('/');
                window.location.reload();
            },10);
            return;
        }
        else{
            if(logoutTimerRef.current){
                clearTimeout(logoutTimerRef.current);
                logoutTimerRef.current = null;
            }
        }
        fetchServerProfiles();
    },[user,tenantAdminProfilesFetched]);
    useEffect(() =>{
        if(selectedTenantAdminProfile && !customersFetched) {
            fetchCustomers();
            setCustomersFetched(true);
        }
    },[customersFetched,selectedTenantAdminProfile]);
    useEffect(() =>{
        if(Array.isArray(tenantAdminProfiles)){
            tenantAdminProfiles.forEach(profile =>{
                if(profile?.defaultProfile) setSelectedTenantAdminProfile(profile);
            });
        }
    },[tenantAdminProfiles]);
    useEffect(() =>{
        if(location.pathname === "/tenants/customers" && customersFetched) setCustomersFetched(false);
    },[location]);
    return(
        <div className="tenant-administrator-customers-page">
            <NavigationBar/>
            <div className="tenant-administrator-customers-page-layout">
                <div>
                    <TenantAdministratorSideBar/>
                </div>
                <div className="tenant-administrator-customers-parent-container">
                    <div className="tenant-administrator-customers-container">
                        <div className="tenant-administrator-customers-header-container">
                            <h2>Customers</h2>
                            <div className="tenant-administrator-customers-header-controls">
                                <select className="tenant-administrator-customers-server-url-select"
                                    onChange={(e) => {
                                        setSelectedTenantAdminProfile(tenantAdminProfiles.find(profile => profile?.id === e.target.value));
                                        setCustomersFetched(false);
                                    }}
                                    value={selectedTenantAdminProfile? selectedTenantAdminProfile?.id:'select'}
                                    defaultValue={'select'}
                                >
                                    <option value={'select'} disabled>Server connection</option>
                                    {tenantAdminProfiles.map((serverProfile,index) => (
                                        <option key={index} value={serverProfile?.id}>{serverProfile?.profileName}</option>
                                    ))}
                                </select>
                                <button className="tenant-administrator-add-new-customer-button" onClick={() => {setShowNewCustomerWindow(true)}}>
                                    <img src={`${process.env.PUBLIC_URL}/images/add-icon.png`} alt="Add" />
                                </button>
                                <button className="tenant-administrator-refresh-customers-button" onClick={() =>{}}>
                                    <img src={`${process.env.PUBLIC_URL}/images/refresh-icon.png`} alt="Refresh"/>
                                </button>
                            </div>
                        </div>
                        {<CustomersTable
                            customers={customers}
                            access_token={user?.access_token}
                            setSelectedComponent={setSelectedComponent}
                        />}
                        {<NewCustomer
                            showNewCustomerWindow={showNewCustomerWindow}
                            setShowNewCustomerWindow={setShowNewCustomerWindow}
                            access_token={user?.access_token}
                            setCustomersFetched={setCustomersFetched}
                        />}
                    </div>
                </div>
            </div>
        </div>
    );
}
export default Customers;